import apiService from '../../apiService';

const INVOICE_TEMPLATE_URL = 'setup/templates'
const invoiceService = {
  
    async createInvoiceTemplate(payload) {
        try {
            const response = await apiService.post(`/${INVOICE_TEMPLATE_URL}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getAllInvoiceTemplate() {
        try {
            const response = await apiService.get(`/${INVOICE_TEMPLATE_URL}`,);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },


    async getSingleInvoiceTemplate(id) {
        try {
            const response = await apiService.get(`/${INVOICE_TEMPLATE_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async updateInvoiceTemplate(payload, id) {
        try {
            const response = await apiService.put(`/${INVOICE_TEMPLATE_URL}/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async deleteInvoiceTemplate(id) {
        try {
            const response = await apiService.delete(`/${INVOICE_TEMPLATE_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response;
        }
    },
};

export default invoiceService;